import 'alpinejs';

declare global {
  interface Window {
    logo_tree: { icon: string };
    logo_text: { icon: string };
    loadMobileNavigationMenu: (a: {
      showMenu: boolean;
      position: string;
      menu: unknown[];
    }) => { showMenu: boolean; position: string; menu: unknown[]; init: () => Promise<void> };
  }
}

// const backSvg =
//   '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0" y="0" viewBox="0 0 100 125" width="15"><polygon points="49.3,86.2 5.3,42.2 15.2,32.3 49.3,66.4 84.1,31.7 94,41.6 "></polygon></svg>';

// let mobileMenuInit = false;

export function initNavMenu() {
  initSubmenuToggle();
  initStickyMenu();
  initFooterNavigation();
}

function initFooterNavigation() {
  if (window.innerWidth < 587) {
    const $toggleAnchors = document.querySelectorAll<HTMLAnchorElement>(
      '.site-footer__menu > ul > li > a',
    );
    $toggleAnchors.forEach($el => {
      $el.addEventListener('click', evt => {
        evt.preventDefault();
        $el.nextElementSibling?.classList.toggle('d-block');
        return false;
      });
    });
  }
}

window.loadMobileNavigationMenu = function ({
  showMenu,
  position,
  menu = [],
}: {
  showMenu: boolean;
  position: string;
  menu: unknown[];
}) {
  return {
    showMenu,
    position,
    menu,
    init: async function () {
      if (this.menu.length) {
        return;
      }
      const res = await fetch('/wp-json/menlo/navigation');
      const data = await res.json();
      this.menu = data;
      return data;
    },
  };
};

/**
 * Initializes the submenu toggle functionality.
 * Creates an event listener for each submenu controller and handles the click event.
 *
 * @return {void}
 */
function initSubmenuToggle(): void {
  // Create event listener for each submenu controller
  const navigationSubmenuControllers = document.querySelectorAll<HTMLUListElement>(
    '.nb-navigation-pane .nb-submenu__controller li',
  );
  navigationSubmenuControllers.forEach($el => {
    $el.addEventListener('click', evt => {
      evt.preventDefault();

      // Remove 'active' from all sibling elements
      const parent: HTMLUListElement | null = $el.closest('ul');
      if (parent && parent.children) {
        const parentChildren = Array.from(parent.children);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        for (const [index, child] of parentChildren.entries()) {
          child.classList.remove('active');
        }
      }

      // Remove 'active' class from columns in the .nb-submenu__content region
      const paneContainer = $el.closest('.nb-navigation-pane');
      if (paneContainer) {
        const columns = paneContainer.querySelectorAll(
          '.nb-submenu__content .nb-submenu__columns',
        );
        columns.forEach(el => {
          el.classList.remove('active');
        });
      }

      // Activate target column area if element has the data-pane-selector attribute
      if ($el.dataset.paneSelector) {
        const mcColumns = document.getElementById($el.dataset.paneSelector);
        if (mcColumns) {
          mcColumns.classList.add('active');
        }
      }

      // Finally, make the clicked element active
      $el.classList.add('active');
    });
  });
}

/**
 * Initializes the sticky menu functionality.
 * Adds 'scroll-down' class to stickyMenu element when scrolling down,
 * removes 'scroll-down' class when scrolling up.
 *
 * @return {void}
 */
function initStickyMenu(): void {
  const stickyMenu = document.querySelector('.sticky-header');
  if (stickyMenu) {
    let lastScrollTop = 0;
    document.addEventListener('scroll', function () {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      setTimeout(function () {
        if (scrollTop > lastScrollTop) {
          // Code for scroll down.
          stickyMenu.classList.add('scroll-down');
        } else {
          // Code for scroll up.
          stickyMenu.classList.remove('scroll-down');
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      }, 250);
    });
  }
}
